import angular from "angular"

angular
  .module("appModule")
  .controller("FormularioCrearAccionController", FormularioCrearAccionController)
  .controller("FormularioEditarAccionController", FormularioEditarAccionController)
  .controller("FormularioEliminarAccionController", FormularioEliminarAccionController)
  .controller("FormularioCrearPlanAccionController", FormularioCrearPlanAccionController)
  .controller("FormularioEditarPlanAccionController", FormularioEditarPlanAccionController)
  .controller("FormularioEliminarPlanAccionController", FormularioEliminarPlanAccionController)
  .controller("FormularioCrearCategoriaController", FormularioCrearCategoriaController)
  .controller("FormularioEditarCategoriaController", FormularioEditarCategoriaController)
  .controller("FormularioEliminarCategoriaController", FormularioEliminarCategoriaController)
  .controller("FormularioCrearTipoAlertaController", FormularioCrearTipoAlertaController)
  .controller("FormularioEditarTipoAlertaController", FormularioEditarTipoAlertaController)
  .controller("FormularioEliminarTipoAlertaController", FormularioEliminarTipoAlertaController)

FormularioCrearAccionController.$inject = [
  "$scope",
  "$mdDialog",
  "CategoriaService",
  "PlanAccionService",
  "saveCallback"
]
function FormularioCrearAccionController(
  $scope,
  $mdDialog,
  CategoriaService,
  PlanAccionService,
  saveCallback
) {
  var self = $scope

  self.tipos_acciones = []

  self.modo = "CREAR"

  CategoriaService.get().$promise.then(function(data) {
    self.tipos_acciones = data.results
  })

  self.loadPlanes = function(params) {
    PlanAccionService.get(params).$promise.then(function(data) {
      self.planes_accion = data.results
      self.plan_accion_id = null
    })
  }

  self.loadPlanes({})

  self.categoriaChange = function() {
    var params
    if (self.tipo_accion_id !== -1) {
      params = { categoria_id: self.tipo_accion_id }
    } else {
      params = {}
    }
    self.loadPlanes(params)
  }

  self.confirmar = function() {
    var data = {
      nombre: self.nombre,
      descripcion: self.descripcion,
      categoria_id: self.tipo_accion_id,
      plan_accion_id: self.plan_accion_id
    }

    saveCallback(data)
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

FormularioEditarAccionController.$inject = ["$scope", "$mdDialog", "saveCallback", "models"]
function FormularioEditarAccionController($scope, $mdDialog, saveCallback, models) {
  var self = $scope
  var modelo = models[0]

  self.tipo_accion = modelo.categoria
  self.plan_accion = modelo.plan_accion
  self.nombre = modelo.nombre
  self.descripcion = modelo.descripcion

  self.confirmar = function() {
    var data = {
      id: modelo.id,
      nombre: self.nombre,
      descripcion: self.descripcion
    }

    saveCallback(data)
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

FormularioEditarPlanAccionController.$inject = ["$scope", "$mdDialog", "saveCallback", "models"]
function FormularioEditarPlanAccionController($scope, $mdDialog, saveCallback, models) {
  var self = $scope
  var modelo = models[0]

  self.tipo_accion = modelo.categoria
  self.nombre = modelo.nombre
  self.descripcion = modelo.descripcion
  self.active = modelo.active

  self.confirmar = function() {
    var data = {
      id: modelo.id,
      nombre: self.nombre,
      descripcion: self.descripcion,
      active: self.active
    }

    saveCallback(data)
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

FormularioEliminarAccionController.$inject = ["$scope", "$mdDialog", "saveCallback"]
function FormularioEliminarAccionController($scope, $mdDialog, saveCallback) {
  var self = $scope

  self.eliminar = function() {
    var data

    data = {
      nombre: self.nombre
    }

    saveCallback(data)
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

FormularioEliminarPlanAccionController.$inject = ["$scope", "$mdDialog", "saveCallback"]
function FormularioEliminarPlanAccionController($scope, $mdDialog, saveCallback) {
  var self = $scope

  self.eliminar = function() {
    var data

    data = {
      nombre: self.nombre
    }

    saveCallback(data)
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

FormularioCrearPlanAccionController.$inject = [
  "$scope",
  "$mdDialog",
  "CategoriaService",
  "PlanAccionService",
  "saveCallback"
]
function FormularioCrearPlanAccionController(
  $scope,
  $mdDialog,
  CategoriaService,
  PlanAccionService,
  saveCallback
) {
  var self = $scope

  self.tipos_acciones = []

  self.modo = "CREAR"

  CategoriaService.get().$promise.then(function(data) {
    self.tipos_acciones = data.results
  })

  PlanAccionService.get().$promise.then(function(data) {
    self.planes_accion = data.results
  })

  self.confirmar = function() {
    var data = {
      nombre: self.nombre,
      descripcion: self.descripcion,
      categoria_id: self.tipo_accion_id
    }

    saveCallback(data)
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

//################ Categorías #################

FormularioCrearCategoriaController.$inject = ["$scope", "$mdDialog", "saveCallback"]
function FormularioCrearCategoriaController($scope, $mdDialog, saveCallback) {
  var self = $scope

  self.crear = function() {
    var data = {
      nombre: self.nombre
    }

    saveCallback(data)
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

FormularioEditarCategoriaController.$inject = ["$scope", "$mdDialog", "saveCallback", "models"]
function FormularioEditarCategoriaController($scope, $mdDialog, saveCallback, models) {
  var self = $scope

  self.nombreCategoria = models.length > 0 ? models[0].nombre : ""
  self.idCategoria = models.length > 0 ? models[0].id : ""
  self.nombre = self.nombreCategoria
  self.isActive = models.length > 0 ? models[0].active : ""
  self.active = self.isActive
  self.editar = function() {
    var data

    if (
      (self.nombreCategoria !== self.nombre || self.active !== self.isActive) &&
      self.nombre !== undefined
    ) {
      data = {
        id: self.idCategoria,
        nombre: self.nombre,
        active: self.active
      }

      saveCallback(data)
    }
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

FormularioEliminarCategoriaController.$inject = [
  "$scope",
  "$mdDialog",
  "atencionesService",
  "saveCallback"
]
function FormularioEliminarCategoriaController($scope, $mdDialog, atencionesService, saveCallback) {
  var self = $scope

  self.eliminar = function() {
    var data

    data = {
      nombre: self.nombre
    }

    saveCallback(data)
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

//################ Tipos Alerta #################

FormularioCrearTipoAlertaController.$inject = ["$scope", "$mdDialog", "saveCallback"]
function FormularioCrearTipoAlertaController($scope, $mdDialog, saveCallback) {
  var self = $scope

  self.crear = function() {
    var data = {
      nombre: self.nombre
    }

    saveCallback(data)
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

FormularioEditarTipoAlertaController.$inject = ["$scope", "$mdDialog", "saveCallback", "models"]
function FormularioEditarTipoAlertaController($scope, $mdDialog, saveCallback, models) {
  var self = $scope

  self.nombreTipoAlerta = models.length > 0 ? models[0].nombre : ""
  self.idTipoAlerta = models.length > 0 ? models[0].id : ""

  self.editar = function() {
    var data

    if (self.nombreTipoAlerta !== self.nombre && self.nombre !== undefined) {
      data = {
        id: self.idTipoAlerta,
        nombre: self.nombre
      }

      saveCallback(data)
    }
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

FormularioEliminarTipoAlertaController.$inject = ["$scope", "$mdDialog", "saveCallback"]
function FormularioEliminarTipoAlertaController($scope, $mdDialog, saveCallback) {
  var self = $scope

  self.eliminar = function() {
    var data

    data = {
      nombre: self.nombre
    }

    saveCallback(data)
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}
